import { FC } from "react"
import { Button } from "@ui/button"

interface Props {
    openImport: () => void
    href: string
}

export const NoProjects: FC<Props> = ({ openImport, href }) => {
    return (
        <div className="flex h-[calc(100%-90px)] flex-col items-center justify-center">
            <div className="align-self-center place-self-center justify-self-center text-center">
                <svg
                    className="mx-auto size-12 text-gray-400"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                    aria-hidden="true"
                >
                    <path
                        vectorEffect="non-scaling-stroke"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M9 13h6m-3-3v6m-9 1V7a2 2 0 012-2h6l2 2h6a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2z"
                    />
                </svg>
                <h3 className="mt-2 text-sm font-semibold text-gray-900">No projects</h3>
                <p className="mt-1 text-sm text-gray-500">Get started by creating a new project.</p>
                <div className="mt-6 space-x-4">
                    <Button onClick={openImport} color="white">
                        Import
                    </Button>
                    <Button href={href} color="primary">
                        Create
                    </Button>
                </div>
            </div>
        </div>
    )
}
